import Vue from 'vue'
import Router from 'vue-router'
// import store from './forms/store/';

const Application = () => import('./forms/index.vue');
const Form = () => import('./forms/form.vue');
const Report = () => import('./report/index.vue');
const Print = () => import('./forms/print.vue');

Vue.use(Router);

const production_base = '/application/',
development_base = '/greenbelt/application/';

/////////////////////////////
// Standard Routes
/////////////////////////////
const myRoutes = [
	{
		path:"/",
		redirect: { name: 'funding_welcome' }
	},
	{
		path:"/timeout",
		name:"timeout",
		component:() => import('./forms/Timeout')
	},
	{
		path: '/funding-request/',
		component: Application,
		meta: { form_type: 'funding', form_name: 'Application for Funding' },
		children: [
			{
				path:"/",
				redirect: 'welcome'
			},
			{
				path: 'welcome',
				name: 'funding_welcome',
				component: () => import('./forms/funding-request/Welcome-Screen')
			},
			{
				path: ':application_hash',
				component: Form,
				children: [
					{
						path:'',
						redirect: 'project-information'
					},
					{
						path:'project-information',
						component: () => import('./forms/funding-request/Project-Information')
					},
					{
						path:'applicant-information',
						component: () => import('./forms/funding-request/Applicant-Information')
					},
					{
						path:'property-information',
						component: () => import('./forms/funding-request/Property-Information')
					},
					{
						path:'acquisition-information',
						component: () => import('./forms/funding-request/Acquisition-Information')
					},
					{
						path:'fair-market-value',
						component: () => import('./forms/funding-request/Fair-Market-Value')
					},
					{
						path:'project-budget',
						component: () => import('./forms/funding-request/project-budget/')
					},
					{
						path:'project-criteria',
						component: () => import('./forms/funding-request/project-criteria/')
					},
					{
						path:'attachments',
						component: () => import('./forms/funding-request/Attachments')
					},
					{
						path:'agreement',
						component: () => import('./forms/funding-request/Agreement')
					},
					{
						path:'exit',
						component: () => import('./forms/funding-request/Exit-Screen')
					},
				]
			},

		]
	},
	{
		path: '/transfer-request/',
		component: Application,
		meta: { form_type: 'transfer', form_name: 'Transfer Request' },
		children: [
			{
				path:"/",
				redirect: 'welcome'
			},
			{
				path: 'welcome',
				component: () => import('./forms/transfer-request/Welcome-Screen')
			},
			{
				path: ':application_hash',
				component: Form,
				children: [
					{
						path:'',
						redirect: 'property-information'
					},
					{
						path:'property-information',
						component: () => import('./forms/transfer-request/Property-Information'),
					},
					{
						path:'requester-information',
						component: () => import('./forms/transfer-request/Requester-Information'),
					},
					{
						path:'compensation',
						component: () => import('./forms/transfer-request/Compensation')
					},
					{
						path:'attachments',
						component: () => import('./forms/transfer-request/Attachments')
					},
					{
						path:'agreement',
						component: () => import('./forms/transfer-request/Agreement')
					},
					{
						path:'exit',
						component: () => import('./forms/transfer-request/Exit-Screen')
					},
				]
			},

		]
	},
	{
		path: '/report/:application_hash',
		name: 'Report',
		component: Report
	},
	{
		path: '/printable/:application_hash',
		name: 'Printable',
		component: Print
	}
]

const router = new Router({
	base: process.env.NODE_ENV === 'production' ? production_base : development_base,
	mode: 'history',
	routes: myRoutes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	}
});

// router.beforeEach( async (to, from, next) => {
// 	try{
// 		if(to.name == "welcome" || to.name == "transfer_request"){
// 			next();
// 		}else{
// 			const status = await store.dispatch('application/getStatus', to.params.application_hash);
// 			// console.log('app status', status, to.name);
// 			if(status == "complete"){
// 				if(to.name == "Printable"){
// 					next();
// 				}
// 				else if(! ['Report', 'exit'].includes(to.name)){
// 					next({name:'Report', params:{application_hash:to.params.application_hash}});
// 				} else{
// 					next();
// 				}
// 			}else{
// 				if(to.name == "Report"){
// 					next({name:'project_information', params:{application_hash:to.params.application_hash}});
// 				} else{
// 					next();
// 				}
// 			}
// 		}
// 	} catch {
// 		// Do a thing
// 	}
// })

export default router;
